import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  public loginForm: FormGroup;
  public isLoaded: boolean = false;
  public isLoading: boolean = false;
  public errorMessage: any;
  passwordFieldType: string = 'password'; // Default type is 'password'
  isPasswordVisible = false;


  constructor(private _formBuilder: FormBuilder,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private _router: Router, private toastService: ToastrService) {
  }

  ngOnInit(): void {
    // if (this.localStorageService.get('user_id')) {
    //   this._router.navigateByUrl('/dashboard');
    // }
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  /**
 * Loader before loading page
 */
  ngAfterViewInit() {
    this.isLoaded = true;
  }

  /**
   * To change nagivations
   * @param route
   */
  public routeChange(route: string): void {
    this._router.navigateByUrl(route);
  }

  /**
   * Signs in
   * @returns
   */
  public signIn() {
    this.isLoading = true;
    if (this.loginForm.invalid) {
      return;
    }
    let payload = {
      name: this.loginForm.value.name,
      email: this.loginForm.value.email,
      password: this.loginForm.value.password,
      confirm_password: this.loginForm.value.cpassword
    }
    this.authService.signIn(payload).subscribe({
      next: (res: any) => {
        console.log('profile',res.data?.profile_url);
        
        this.isLoading = false;
        this.localStorageService.set('user', res.data);
        this.localStorageService.set('authentication', res.data.authentication_token);
        this.localStorageService.set('session', res.data.session_token);
        this.localStorageService.set('user_id', res.data.user_id);
        this.localStorageService.set('profile_image','assets/images/user-profile.jpg');
        this.toastService.success(res.message);
        this.routeChange('dashboard');
      },
      error: (err: HttpErrorResponse) => {
        console.log(err);
        this.isLoading = false;
        this.errorMessage = err.error.message;
      },
    });
  }

  /**
   * Toggles password visibility
   */
  // togglePasswordVisibility() {
  //   this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  // }


  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

}
